import React from 'react';

import { Box, Chip, Typography } from '@mui/material';

import { TourOfferDeparture } from '~/types/tours/tourOffer';

import { isTourAvailable, spacesLeft } from './tourAvailability';

interface Props {
  departure: TourOfferDeparture | undefined;
}

export default function TourSpaces({ departure }: Props) {
  if (!departure) return null;
  const isAvailable = isTourAvailable(departure);
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="body2" color={isAvailable ? 'text.primary' : 'text.secondary'}>
        Single {spacesLeft(departure, 'single')} · Twin {spacesLeft(departure, 'twin')}
      </Typography>
      <Chip
        size="small"
        variant="outlined"
        label={isAvailable ? 'Available' : 'Not available'}
        color={isAvailable ? 'success' : 'error'}
      />
    </Box>
  );
}
